var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prizes-arrow",attrs:{"id":"prizes-arrow"},on:{"click":function($event){return _vm.scrollToPrizes()}}},[_c('div',{staticClass:"text"},[_vm._v("Prizes")]),_c('div',{staticClass:"arrows"})])}
var staticRenderFns = []

export { render, staticRenderFns }